/**
     * @desc 查询当前用户token
前端登录portal获取钱包地址，将钱包地址作为参数调用该接口获取api访问的鉴权token
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/system/getToken', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/system/getToken', params);
}
